/* eslint-disable react/jsx-no-useless-fragment */

import { Button, Close } from '@core/ui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const BroadcastDialog = ({
    open,
    onClose,
    children,
    isCloseFunctionality
}: {
    children: ReactNode;
    open: boolean;
    onClose: () => void;
    isCloseFunctionality: boolean;
}) => {
    if (!open) {
        return <></>;
    }

    const { t } = useTranslation();

    return (
        <div className="fixed inset-0 bg-primary/95 flex overflow-auto z-50 popup-sm-wrapper">
            <div className="relative w-full max-w-lg bg-white rounded-lg flex-col flex m-auto opacity-100 p-8 popup-sm">
                <div>{children}</div>
                {isCloseFunctionality && (
                    <div className="absolute top-2 right-2">
                        <Button iconbtn onClick={onClose} aria-label={t('Generic.Dialog.Button.Close')}>
                            <Close classNames="size-6 stroke-current" />
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};
